export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled

  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.evg_sku_spec_material_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },

  {
    title: that.$l('INDEX.evg_sku_label_specName') || '规格名称',
    field: 'specName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'specName' },
  },

  {
    title: that.$l('INDEX.evg_sku_label_size_quantity') || '尺寸及数量',
    field: 'goodsLength',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'goodsLength' },
  },
  {
    title: that.$l('INDEX.evg_sku_label_materialUseQty') || '使用数量',
    field: 'materialUseQty',
    minWidth: 150,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInputNumber',
      props: {
        precision: 0,
        min: 0,
        max: 2147483647,
        controls: false,
        style: 'width:100%',
        clearable: true,
        size: 'mini',
      },
    },
  },
]
